import { configureStore } from "@reduxjs/toolkit";
import adminReducer from "../store/adminSlice"

export const store = configureStore({
    reducer: adminReducer
});